





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Checkbox, Input, Form, FormItem } from 'element-ui';
import Channel from '@/components/channel/Channel.vue';
import ChannelUpsert from '@/components/channel/ChannelUpsert.vue';
import { ChannelFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    Channel,
    ChannelUpsert
  }
})
export default class ChannelBar extends Vue {
  // array of channel id
  @Prop({ required: true, type: Array }) channelList!: string[];

  channels = this.channelList;
  editing = null;

  closeChannel(id: string, index: number) {
    sessionStorage.removeItem(`channel-${id}-status`);
    this.channels.splice(index, 1);
  }
}
